import {
  jb_legal_icon_css_default
} from "./chunk.IKEFU3CH.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-legal-icon/jb-legal-icon.ts
var JbLegalIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 12.3433C17 12.9155 16.7937 13.4305 16.3812 13.8883C15.9851 14.346 15.4406 14.7302 14.7475 15.0409C15.1766 15.3351 15.5314 15.6948 15.8119 16.1199C16.1089 16.5286 16.2574 17.0272 16.2574 17.6158C16.2574 18.0245 16.1584 18.4332 15.9604 18.842C15.7624 19.2507 15.4653 19.6185 15.0693 19.9455C14.6898 20.2561 14.2195 20.5095 13.6584 20.7057C13.0974 20.9019 12.4455 21 11.703 21C10.8449 21 10.0033 20.8529 9.17822 20.5586C8.35314 20.2643 7.62706 19.8801 7 19.406L7.86634 18.1553C8.37789 18.564 8.98845 18.9155 9.69802 19.2098C10.4241 19.4877 11.1337 19.6267 11.8267 19.6267C12.7178 19.6267 13.4191 19.4469 13.9307 19.0872C14.4587 18.7112 14.7228 18.2207 14.7228 17.6158C14.7228 17.3215 14.6403 17.0599 14.4752 16.8311C14.3102 16.5858 14.0792 16.3733 13.7822 16.1935C13.5016 15.9973 13.1716 15.8256 12.7921 15.6785C12.4125 15.515 12.0083 15.3515 11.5792 15.188C11.0017 14.9755 10.4406 14.7629 9.89604 14.5504C9.35149 14.3215 8.87294 14.0681 8.4604 13.7902C8.04785 13.5123 7.71782 13.1935 7.4703 12.8338C7.22277 12.4578 7.09901 12.0245 7.09901 11.5341C7.09901 10.8801 7.31353 10.3243 7.74257 9.86649C8.18812 9.40872 8.72442 9.05722 9.35148 8.81199C8.87294 8.48501 8.5099 8.12534 8.26238 7.73297C8.01485 7.32425 7.89109 6.87466 7.89109 6.3842C7.89109 5.92643 7.9901 5.49319 8.18812 5.08447C8.38614 4.6594 8.67492 4.29973 9.05446 4.00545C9.43399 3.69482 9.88779 3.44959 10.4158 3.26976C10.9604 3.08992 11.571 3 12.2475 3C13.0891 3 13.8812 3.13079 14.6238 3.39237C15.3663 3.65395 16.0016 3.9564 16.5297 4.29973L15.7624 5.55041C15.2343 5.19074 14.665 4.90463 14.0545 4.6921C13.4604 4.46322 12.8333 4.34877 12.1733 4.34877C11.3317 4.34877 10.6551 4.52044 10.1436 4.86376C9.64851 5.19074 9.40099 5.64033 9.40099 6.21253C9.40099 6.50681 9.47525 6.76839 9.62376 6.99728C9.77228 7.22616 9.9868 7.43869 10.2673 7.63488C10.5644 7.83106 10.9109 8.01907 11.3069 8.19891C11.7195 8.37875 12.1815 8.56676 12.6931 8.76294C13.2871 8.99183 13.8399 9.22071 14.3515 9.44959C14.8795 9.66213 15.3416 9.90736 15.7376 10.1853C16.1337 10.4469 16.4389 10.7493 16.6535 11.0926C16.8845 11.436 17 11.8529 17 12.3433ZM11.5545 9.94005C11.3399 9.85831 11.1419 9.77657 10.9604 9.69482C10.7789 9.59673 10.5974 9.50681 10.4158 9.42507C9.88779 9.6049 9.45875 9.85831 9.12871 10.1853C8.79868 10.5123 8.63366 10.8883 8.63366 11.3134C8.63366 11.6403 8.72442 11.9264 8.90594 12.1717C9.10396 12.4005 9.35974 12.6131 9.67327 12.8093C10.0033 12.9891 10.3746 13.1608 10.7871 13.3243C11.1997 13.4877 11.6287 13.6512 12.0743 13.8147C12.3548 13.9128 12.6271 14.0191 12.8911 14.1335C13.1716 14.2316 13.4521 14.346 13.7327 14.4768C14.2112 14.297 14.6238 14.0354 14.9703 13.6921C15.3168 13.3488 15.4901 12.9646 15.4901 12.5395C15.4901 12.1962 15.3746 11.9101 15.1436 11.6812C14.929 11.436 14.6403 11.2153 14.2772 11.0191C13.9142 10.8229 13.4934 10.6431 13.0149 10.4796C12.5363 10.3161 12.0495 10.1362 11.5545 9.94005Z"
          fill="currentColor"
        />
      </svg>
      <slot></slot>
    `;
  }
};
JbLegalIcon.styles = [reset_css_default, jb_legal_icon_css_default];
JbLegalIcon = __decorateClass([
  customElement("jb-legal-icon")
], JbLegalIcon);

export {
  JbLegalIcon
};
